import { useTranslations } from 'next-intl';
import {
  ContentLayout,
  PromoPageContent,
} from '@silvertours/common-landingpages-view';
import { StageLegacy, ContentArticle } from '@silvertours/front-features';

import styled from '@emotion/styled';
import { Body } from '../body';

/**
 * This is a page template for promotional content that renders the introduction above the stage.
 * Unlike other page templates, the introduction content appears before the stage component.
 * Suitable for special promotions, time-sensitive offers, and campaigns.
 */

const PromoContentArticleContainer = styled.div`
  margin-top: -1rem;
  text-align: center;

  h2 {
    padding: 0 1rem;

    ${({ theme }) => theme.mq('sm')} {
      padding: 0 2rem;
    }
  }
`;

const PromoPage = ({
  content: {
    article,
    introduction,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<PromoPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);

  const introductionContent = introduction?.segments ? (
    <PromoContentArticleContainer>
      <ContentArticle
        modules={introduction.segments}
        translations={translations}
      />
    </PromoContentArticleContainer>
  ) : null;

  return (
    <Body
      title={primaryHeadline}
      stage={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          isPlain
          isPromoPage
        />
      }
      introductionContent={introductionContent}
      content={({ container, contentModule }) => [
        // We don't include introduction here as it's rendered above the stage
        container('content-modules', [
          contentModule(
            'article',
            <ContentArticle
              modules={article.segments}
              translations={translations}
            />,
          ),
        ]),
      ]}
      includeSearch={stage.content.includeSearch}
      isPlain
      isPromo
      {...commonProps}
    />
  );
};

export { PromoPage };
